var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_354_52352"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 16,
    height: 16,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_354_52352)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M14.2313,2.501156916015625L5.43417,11.298278916015626L1.7687,7.633848916015625C1.36638,7.230488916015625,0.705875,7.230488916015625,0.302518,7.633848916015625C-0.100839,8.037208916015626,-0.100839,8.696678916015625,0.302518,9.100038916015624L4.69486,13.492338916015624C4.69693,13.494438916015625,4.69797,13.496538916015625,4.70004,13.498638916015626C4.9012,13.700838916015625,5.16769,13.801338916015625,5.43417,13.801338916015625C5.70066,13.801338916015625,5.96611,13.700838916015625,6.1683,13.498638916015626C6.17038,13.496538916015625,6.17141,13.494438916015625,6.17349,13.492338916015624L15.6975,3.967338916015625C16.1008,3.5639889160156253,16.1008,2.904513916015625,15.6975,2.501156916015625C15.2941,2.097799916015625,14.6347,2.097799916015625,14.2313,2.501156916015625Z",
    fillRule: "evenodd",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApply);
export default __webpack_public_path__ + "static/media/apply.d163f4d1dfb012dee5f487efe99c174a.svg";
export { ForwardRef as ReactComponent };